import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeAnalyticsData } from '@atlassian/mpac-analytics';
import { foldAuthType } from '@atlassian/mpac-types';
import { foldInstallableAppIdentifier } from '../records/InstallableAppIdentifier';
import { resolveFieldWithFallback } from '../utils/common-utils';
import { ANALYTICS_CATEGORY_NAVIGATION } from './Events';
export function makeAnalyticsForInstallableAppIdentifier(eventType, actionSubjectId, installableAppId, extraAttributes) {
  return makeAnalyticsData({
    eventType,
    actionSubjectId,
    objectType: 'app',
    objectId: foldInstallableAppIdentifier(installableAppId)(installableAppByKeyId => installableAppByKeyId.key, installableAppByUrlId => installableAppByUrlId.url, installableAppByARI => installableAppByARI.appKey),
    attributes: extraAttributes,
    category: ANALYTICS_CATEGORY_NAVIGATION
  });
}
export function makeAnalyticsForInstalledApp(eventType, actionSubjectId, installedApp, extraAttributes) {
  return foldAuthType(installedApp.authType)(_ => makeAnalyticsData({
    eventType,
    actionSubjectId,
    objectType: 'token',
    attributes: _objectSpread(_objectSpread({}, extraAttributes), {}, {
      authType: 'token'
    }),
    category: ANALYTICS_CATEGORY_NAVIGATION
  }), _ => makeAnalyticsData({
    eventType,
    actionSubjectId,
    objectType: 'app',
    objectId: installedApp.details.key,
    attributes: _objectSpread(_objectSpread({}, extraAttributes), {}, {
      name: resolveFieldWithFallback(add => add.name, installedApp.marketplaceAppDetails, installedApp.details),
      oauthClientId: installedApp.details.metadata.oauthClientId,
      authType: '2LO'
    }),
    category: ANALYTICS_CATEGORY_NAVIGATION
  }), _ => makeAnalyticsData({
    eventType,
    actionSubjectId,
    objectType: 'app',
    objectId: installedApp.details.key,
    attributes: _objectSpread(_objectSpread({}, extraAttributes), {}, {
      name: resolveFieldWithFallback(add => add.name, installedApp.marketplaceAppDetails, installedApp.details),
      oauthClientId: installedApp.details.metadata.oauthClientId,
      authType: '3LO'
    }),
    category: ANALYTICS_CATEGORY_NAVIGATION
  }));
}